import { get_token } from "@/router";
import Swal from "sweetalert2";



export default {
    name: "Delivery",
    data: () => ({
        // Customer checkout
        selected_pickup_point: null,
        selected_pickup_point_name: null,
        // Business drop-off
        selected_drop_off_point_name: null,
        selected_drop_off_point: null,
        delivery_amount: 0,
        pargo_map_url: process.env.VUE_APP_PARGO_MAP_URL,
    }),

    mounted() {
        if (!this.is_checkout) {
            this.Fetch_drop_off_point();
        }
        window.addEventListener("message", this.handle_pargo_message);

    },
    beforeUnmount() {
        window.removeEventListener("message", this.handle_pargo_message);
    },
    props: {
        base_profile_id: {
            type: Number,
            required: true
        }
    },


    computed: {
        is_checkout() {
            // Use route name or path
            return this.$route.path.includes('/cart_checkout');
        }
    },

    methods: {

        calculate_delivery() {
            if (!this.selected_pickup_point) {
                this.delivery_amount = null;
                return;
            }
            // Example: fixed fee per pickup point
            const feePerPoint = 60; // you can also fetch this from backend
            this.delivery_amount = feePerPoint;
            this.$emit('update-delivery-fee', this.delivery_amount);
            this.$emit('pickup-point-selected', {
                pickup_point_code: this.selected_pickup_point,
                pickup_point_name: this.selected_pickup_point_name
            });


        },
        handle_pargo_message(event) {
            if (!event.origin.includes("map.pargo.co.za")) return;
            const data = event.data;
            if (this.is_checkout) {
                // Checkout map: set selected pickup point
                this.selected_pickup_point = data.pargoPointCode;
                this.selected_pickup_point_name = data.storeName;
                this.calculate_delivery();
            } else {
                // Seller map: set drop-off point
                this.selected_drop_off_point = data.pargoPointCode;
                this.selected_drop_off_point_name = data.storeName;
                this.Handle_drop_off_point();
            }
        },


        Handle_drop_off_point() {
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/add_drop_off_point/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${get_token()}`,
                    'Content-Type': 'application/json',

                },
                data: JSON.stringify({
                    drop_off_code: this.selected_drop_off_point,
                    drop_off_store_name: this.selected_drop_off_point_name,
                    base_profile_id: this.base_profile_id, // from prop

                }),
                success: (response) => {
                    const data = response.data
                    Swal.fire({
                        icon: "success",
                        title: "Saved",
                        text: "Drop-off point added successfully",
                        timer: 2000,
                        showConfirmButton: false,
                        position: 'bottom-end',
                        toast: true
                    });
                    this.selected_drop_off_point = data.drop_off_code;
                    this.selected_drop_off_point_name = data.drop_off_store_name;

                    // OPTIONAL: store locally
                    this.saved_drop_off = response.data;
                },
                error: (err) => {
                    this.loading = false;

                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: err.responseJSON?.message || "Something went wrong",
                        position: 'bottom-end',
                        showConfirmButton: false,
                        timer: 3000,
                        toast: true
                    });

                    console.error(err);
                }
            });
        },
        Fetch_drop_off_point() {
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_drop_off_point/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${get_token()}`,
                    'Content-Type': 'application/json',

                },
                data: JSON.stringify({
                    base_profile_id: this.base_profile_id, // from prop

                }),
                success: (response) => {
                    const data = response.data
                    this.selected_drop_off_point = data.drop_off_code;
                    this.selected_drop_off_point_name = data.drop_off_store_name;

                },
            });
        }

    }
};
